<!-- 快录添加费用 -->
<template>
  <div class="app-container">
    <div class="addTable">
      <el-card class="mb5">
        <el-form
          ref="basicInformation" :model="addBatchFee.basicInformation"
          label-width="auto"
          label-position="top"
          size="small"
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <!--业务单号-->
              <el-form-item
                :label="$t('receivablePayable.TicketNumber') + '：'"
                prop="waybillNumber"
                :rules="[
                  { required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] },
                  { max: 28, message: $t('basicData.LengthCantExceed30'), trigger: ['blur', 'change'] }
                ]"
              >
                <div style="display:flex;">
                  <el-input v-model="addBatchFee.basicInformation.waybillNumber" :disabled="!!queryFeeParam.id">
                    <template slot="prepend">QR</template>
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!--客户-->
              <el-form-item
                :label="$t('receivablePayable.customer') + '：'"
                prop="customerId"
                :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              >
                <el-select
                  v-model="addBatchFee.basicInformation.customerId"
                  filterable
                  clearable
                  :placeholder="$t('spareNumberPoo.pleaseChoose')"
                  style="width: 100%;"
                  :disabled="!!queryFeeParam.id"
                  @change="changeCustomer"
                >
                  <el-option
                    v-for="(item, ind) in customerList"
                    :key="ind"
                    :label="item.customerAlias + '(' + item.username + ')'"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!--应付主体-->
              <el-form-item :label="$t('basicData.PayablePrincipal') + '：'">
                <el-input v-model="addBatchFee.basicInformation.providerName" :disabled="true" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!--网点-->
              <el-form-item
                :label="$t('userManage.site') + '：'"
                prop="siteId"
                :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              >
                <QuerySiteV2Cmp
                  style="width: 100%;"
                  provider-id=""
                  :disabled="!!queryFeeParam.id"
                  :val="addBatchFee.basicInformation.siteId"
                  @change="val => addBatchFee.basicInformation.siteId = val"
                  @row="changeOutlets"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!--计费重量-->
              <el-form-item
                :label="$t('receivablePayable.BillableWeight') + '：'"
                prop="chargeWeight"
                :rules="{ required: true, suffix: 3, negative: '', validator: priceType, trigger: ['blur', 'change'] }"
              >
                <el-input v-model="addBatchFee.basicInformation.chargeWeight" :disabled="!!queryFeeParam.id" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!--业务类型-第三方-->
              <el-form-item
                v-if="[2].includes(payableType)"
                :label="$t('collectionCenter.businessT') + '：'"
                prop="orderBusinessType"
                :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              >
                <el-select
                  v-model="addBatchFee.basicInformation.orderBusinessType"
                  :placeholder="$t('basicData.PleaseSelect')"
                  style="width: 100%;"
                  :disabled="!!queryFeeParam.id"
                >
                  <!--快递-->
                  <el-option :key="1" :label="$t('basicData.CourierSystemBusiness')" :value="1" />
                  <!--揽收-->
                  <el-option :key="0" :label="$t('basicData.CollectionSystemBusiness')" :value="0" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!--揽收方式 安骏、第三方-->
              <el-form-item
                v-if="[1, 2].includes(payableType)"
                :label="$t('collectionCenter.lanshouType')"
                prop="collectType"
                :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              >
                <el-select
                  v-model="addBatchFee.basicInformation.collectType"
                  :placeholder="$t('basicData.PleaseSelect')"
                  style="width: 100%;"
                  :disabled="!!queryFeeParam.id"
                >
                  <el-option
                    v-for="(item, ind) in COLLECT_TYPE"
                    :key="ind"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="payableType === 6" :span="8">
              <!--服务商渠道-邮局派送展示-->
              <el-form-item
                :label="$t('GlobalSetObj.ServiceProviderChannels') + '：'"
                prop="providerChannelId"
                :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
              >
                <el-select
                  v-model="addBatchFee.basicInformation.providerChannelId"
                  filterable
                  clearable
                  :placeholder="$t('GlobalSetObj.pleaseSelectChannel')"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in ProviderChannelList"
                    :key="item.id"
                    :label="item.providerChannelName"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--备注-->
              <el-form-item
                :label="$t('receivablePayable.remark') + '：'"
                prop="remark"
                :rules="{ max: 200, message: $t('basicData.LengthCantExceed200'), trigger: ['blur', 'change'] }"
              >
                <el-input
                  v-model="addBatchFee.basicInformation.remark" :rows="4" type="textarea"
                  :disabled="!!queryFeeParam.id"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <!--费用明细-->
      <el-card class="mb5">
        <div slot="header">
          <span>{{ $t('receivablePayable.FeeBreakdown') }}</span>
        </div>
        <el-form
          ref="addBatchFee" :model="addBatchFee"
          label-width="0"
          size="small"
        >
          <el-table
            :key="key"
            :data="addBatchFee.expenseSubList"
            :height="tableHeight"
            border
            class="CostDetails error-table"
          >
            <el-table-column width="55" align="center">
              <template slot="header">
                <span class="el-icon-plus addStyle" @click="addCost" />
              </template>
              <template slot-scope="scope">
                <!--确定删除吗？-->
                <el-popconfirm
                  :title="$t('basicData.AreYouSureDelete')"
                  @confirm="deleteCost(scope)"
                >
                  <span slot="reference" class="el-icon-delete deleteStyle" />
                </el-popconfirm>
              </template>
            </el-table-column>
            <!--费用类型-->
            <el-table-column
              prop="feeName"
              :label="$t('basicData.ExpenseType')"
              width="180"
            >
              <template slot="header">
                <div>
                  <span style="color: #f00;margin-right: 5px;">*</span>
                  <span>{{ $t('basicData.ExpenseType') }}</span>
                </div>
              </template>
              <template slot-scope="scope">
                <div class="formStyle">
                  <div v-if="!scope.row.isEdit">{{ scope.row.feeName }}</div>
                  <el-form-item
                    v-else
                    :prop="'expenseSubList.' + scope.$index + '.feeCode'"
                    :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                  >
                    <el-select
                      v-model="scope.row.feeCode"
                      filterable
                      clearable
                      :placeholder="$t('operationCenter.PleaseSelect')"
                      style="width: 100%;"
                      @change="feeTypeChange(scope)"
                    >
                      <el-option
                        v-for="item in feeTypeList"
                        :key="item.id"
                        :label="item.displayName"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <!--应付金额-->
            <el-table-column
              prop="fee"
              :label="$t('receivablePayable.AmountDue')"
              width="160"
            >
              <template slot="header">
                <div>
                  <span style="color: #f00;margin-right: 5px;">*</span>
                  <span>{{ $t('receivablePayable.AmountDue') }}</span>
                </div>
              </template>
              <template slot-scope="scope">
                <div class="formStyle">
                  <div v-if="!scope.row.isEdit">{{ scope.row.fee }}</div>
                  <el-form-item
                    v-else
                    :prop="'expenseSubList.' + scope.$index + '.fee'"
                    :rules="{ required: true, suffix: 2, negative: '-?', validator: priceType, trigger: ['blur', 'change'] }"
                  >
                    <el-input v-model="scope.row.fee" />
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <!--业务时间-->
            <el-table-column
              prop="operateTime"
              :label="$t('basicData.BusinessTime')"
              width="220"
            >
              <template slot="header">
                <div>
                  <span style="color: #f00;margin-right: 5px;">*</span>
                  <span>{{ $t('basicData.BusinessTime') }}</span>
                </div>
              </template>
              <template slot-scope="scope">
                <div class="formStyle">
                  <div v-if="!scope.row.isEdit">{{ scope.row.operateTime }}</div>
                  <el-form-item
                    v-else
                    :prop="'expenseSubList.' + scope.$index + '.operateTime'"
                    :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                  >
                    <el-date-picker
                      v-model="scope.row.operateTime"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 100%;"
                      :placeholder="$t('basicData.SelectADatetime')"
                    />
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <!--操作人-->
            <el-table-column :label="$t('basicData.Operator')" prop="operator" width="180">
              <template slot="header">
                <div>
                  <span style="color: #f00;margin-right: 5px;">*</span>
                  <span>{{ $t('basicData.Operator') }}</span>
                </div>
              </template>
              <template slot-scope="scope">
                <div class="formStyle">
                  <div v-if="!scope.row.isEdit">{{ scope.row.operatorName }}</div>
                  <el-form-item
                    v-else
                    :prop="'expenseSubList.' + scope.$index + '.operator'"
                    :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                  >
                    <!--AJD-->
                    <QueryPmUserV2Cmp
                      v-if="payableType === 3"
                      :val="scope.row.operator"
                      @change="val => scope.row.operator = val"
                    />
                    <QueryUserV2Cmp v-else :val="scope.row.operator" @change="val => scope.row.operator = val" />
                  </el-form-item>
                </div>
              </template>
            </el-table-column>
            <!--备注-->
            <el-table-column
              prop="remark"
              :label="$t('receivablePayable.remark')"
            >
              <template slot-scope="scope">
                <div v-if="!scope.row.isEdit">{{ scope.row.remark }}</div>
                <el-form-item
                  v-else
                  :prop="'expenseSubList.' + scope.$index + '.remark'"
                  :rules="{ max: 200, message: $t('basicData.LengthCantExceed200'), trigger: ['blur', 'change'] }"
                >
                  <el-input v-model="scope.row.remark" :placeholder="$t('GlobalSetObj.pleaseInputContent')" />
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </el-card>
    </div>

    <div class="footerBtn">
      <!--保存-->
      <el-button
        v-permit:remove="permission" type="primary" size="small"
        @click="saveData(2)"
      >{{ $t('basicData.Save') }}</el-button>
      <!--关闭-->
      <el-button size="small" @click="saveData(1)">{{ $t('orderCenterCont.ShutDown') }}</el-button>
    </div>
  </div>

</template>

<script>
import { cloneDeep } from 'lodash-es';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import {
  apiPayableSiteExpenseFastInputFee,
  apiPayableSiteExpenseAddFee,
  apiPayableSiteExpenseDelete
} from '@/api/finance/receivables';
import { apiGetCustomerNewPage } from '@/api/finance/contasDeClientes';
import { apiProviderChannel, apiProviderPage } from '@/api/finance/basicData';
import { QUERY_FEE_PARAM } from '@/views/finance/payableManage/feesPayable/enums.js';
import { COLLECT_TYPE } from '@/views/finance/enums';
import { getPermission } from './AddFeee/utils';

export default {
  name: 'AddQRFee',

  components: {
    QuerySiteV2Cmp: () => import('@/views/finance/cmp/Query/QuerySiteV2Cmp.vue'),
    QueryUserV2Cmp: () => import('@/views/finance/cmp/Query/QueryUserV2Cmp.vue'),
    QueryPmUserV2Cmp: () => import('@/views/finance/cmp/Query/QueryPmUserV2Cmp.vue')
  },

  props: {
    // 搜索数据
    queryForm: {
      type: Object,
      default: () => {
        return {};
      }
    },

    // 费用类型（后端请求）
    feeTypeOption: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 快录明细
    queryFeeParam: {
      type: Object,
      default: () => {
        return {
          ...QUERY_FEE_PARAM
        };
      }
    },

    // 费用明细（后端请求）
    expenseSubList: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 账单类型
    payableType: {
      type: Number,
      required: true
    },

    // 勾选
    selectData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    const priceType = (rule, value, callback) => {
      const reg = new RegExp('(^' + rule.negative + '[1-9]\\d*(\\.\\d{1,' + rule.suffix + '})?$)|(^' + rule.negative + '0(\\.\\d{1,' + rule.suffix + '})?$)');
      const { required } = rule;
      if (!required) {
        // 非必填
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$i18n.t('basicData.IncorrectFormatting'))); // 格式不正确
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$i18n.t('basicData.IncorrectFormatting'))); // 格式不正确
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          this.adopt = false;
          return callback(this.$i18n.t('basicData.CannotBeEmpty')); // '不能为空'
        }
      }
    };
    return {
      key: new Date().getTime(),
      addBatchFee: {
        basicInformation: {
          ...QUERY_FEE_PARAM
        },
        expenseSubList: []
      },

      showAddSnapshotFee: false, // 弹出框

      priceType: priceType,
      createUser: null,
      customerList: [],
      outletsList: [],
      feeTypeList: [],
      ProviderChannelList: [], // 服务商下拉
      providerName: '', // 业务主体名称
      permission: '', // 权限
      COLLECT_TYPE,
      tableHeight: 200
    };
  },

  activated() {
    this.permission = getPermission(this.payableType);
  },

  created() {
    this.tableHeight = document.body.clientHeight - 583;

    // 费用类型
    this.feeTypeList = cloneDeep(this.feeTypeOption);
    this.createUser = getUserIdAndNameObj();

    this.addBatchFee.basicInformation = cloneDeep(this.queryFeeParam);
    if (this.queryFeeParam.id) {
      this.addBatchFee.expenseSubList = cloneDeep(this.expenseSubList);
    }

    this.permission = getPermission(this.payableType);

    this.$nextTick(() => {
      // 获取客户
      this.getCustomerPage();

      this.getProviderChannel();
    });
  },

  mounted() {
    // 页面加载的时候设置table的高度
    this.tableHeight = document.body.clientHeight - 583;
    // 页面大小该变的时候（缩放页面）设置table的高度（可加可不加）
    window.onresize = () => {
      this.tableHeight = document.body.clientHeight - 583;
    };
  },
  methods: {
    // 费用类型变化
    feeTypeChange(scope) {
      this.feeTypeList.map(item => {
        if (item.code === scope.row.feeCode) {
          this.addBatchFee.expenseSubList[scope.$index].feeName = item.name;
        }
      });
    },

    // 网点选项变化
    changeOutlets(obj) {
      const { label, providerId } = obj;
      this.addBatchFee.basicInformation.siteName = label;
      // 网点反推主体
      this.asyncapiProviderPage(providerId);
    },
    asyncapiProviderPage(id) {
      const param = {
        pageNumber: 1,
        pageSize: 1,
        params: {
          id
        }
      };

      apiProviderPage(param, false).then(res => {
        const { records } = res.data;
        if (records.length > 0) {
          this.providerName = records[0].providerBody;
          this.addBatchFee.basicInformation.providerName = records[0].providerBody;
        }
      }).catch(err => {
        console.log(err);
      });
    },

    // 获取客户
    getCustomerPage(name = '') {
      const param = {
        pageSize: 9999999,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiGetCustomerNewPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    // 客户选项变化
    changeCustomer() {
      this.customerList.map(item => {
        if (this.addBatchFee.basicInformation.customerId === item.id) {
          this.addBatchFee.basicInformation.customerAlias = item.customerAlias;
        }
      });
    },
    /**
     * 获取服务商下拉数据
     * @params id 主体id
     */
    getProviderChannel() {
      const query = {
        pageNumber: 1,
        pageSize: 9999999,
        params: {
          providerChannelCode: '',
          providerChannelName: ''
        }
      };
      apiProviderChannel(query).then(res => {
        if (res.code === 200) {
          this.ProviderChannelList = res.data.records || [];
        }
      });
    },
    /**
     * 保存快录费用信息
     * @param type
     */
    saveData(type) {
      if (type === 2) {
        this.$refs.basicInformation.validate((validIs) => {
          if (validIs) {
            const basicInformation = {
              id: this.addBatchFee.basicInformation.id,
              waybillNumber: 'QR' + this.addBatchFee.basicInformation.waybillNumber, // 业务单号
              businessType: this.queryForm.params.businessType, // 业务类型
              customerId: this.addBatchFee.basicInformation.customerId, // 客户id
              customerAlias: this.addBatchFee.basicInformation.customerAlias, // 客户别称
              siteId: this.addBatchFee.basicInformation.siteId, // 网点id
              siteName: this.addBatchFee.basicInformation.siteName, // 网点名称
              providerChannelId: this.addBatchFee.basicInformation.providerChannelId, // 服务商渠道id
              collectType: this.addBatchFee.basicInformation.collectType, // 揽收类型
              providerId: null,
              remark: this.addBatchFee.basicInformation.remark, // 备注
              chargeWeight: this.addBatchFee.basicInformation.chargeWeight, // 计费重量
              operationMode: this.queryForm.params.operationMode, // 派送方式
              orderBusinessType: this.addBatchFee.basicInformation.orderBusinessType // 订单业务类型
            };
            this.$refs.addBatchFee.validate((valid) => {
              if (valid) {
                const list = this.addBatchFee.expenseSubList
                  .filter(item => item.isEdit)
                  .map(item => ({
                    feeCode: item.feeCode,
                    feeName: item.feeName,
                    operateTime: item.operateTime,
                    remark: item.remark,
                    fee: item.fee,
                    operator: item.operator
                  }));
                if (!basicInformation.id && this.addBatchFee.expenseSubList.length === 0) {
                  this.$message.warning(this.$t('receivablePayable.AddAtLeastOneCharge'));
                  return;
                }

                let param = {
                  payableType: this.payableType
                };
                if (!basicInformation.id) {
                  param = {
                    ...param,
                    ...basicInformation,
                    expenseFastInputSubDTOList: list
                  };
                } else {
                  param = {
                    ...param,
                    expenseSubList: list,
                    waybillNumber: basicInformation.waybillNumber,
                    businessType: basicInformation.businessType,
                    operationMode: basicInformation.operationMode
                  };
                }

                const apiCall = basicInformation.id ? apiPayableSiteExpenseAddFee : apiPayableSiteExpenseFastInputFee;
                apiCall(param).then(res => {
                  if (res.code === 200) {
                    this.showSuccessMessage();
                    this.$emit('saveFormSnapshot', true);
                  }
                });
              }
            });
          }
        });
      } else {
        this.$emit('saveFormSnapshot', false);
      }
    },
    showSuccessMessage() {
      this.$message.success(this.$i18n.t('GlobalSetObj.SaveSuccessfully'));
    },
    /**
     * 删除费用明细
     * @param scope
     */
    deleteCost(scope) {
      const deleteItem = () => {
        this.addBatchFee.expenseSubList.splice(scope.$index, 1);
        if (this.addBatchFee.expenseSubList.length === 0) {
          setTimeout(() => {
            this.$emit('saveFormSnapshot', true);
          }, 300);
        }
      };

      if (scope.row.id) {
        apiPayableSiteExpenseDelete({ id: scope.row.id })
          .then(res => {
            if (res.code === 200) {
              this.$message.success(this.$i18n.t('basicData.TheOperationSucceeded'));
              deleteItem();
            }
          })
          .catch(() => {
            console.log('删除失败');
          });
      } else {
        deleteItem();
      }
    },
    /**
     * 添加费用明细
     */
    addCost() {
      const data = {
        isEdit: true,
        feeName: '', // 费用类型
        feeCode: '', // 费用类型代码
        fee: '', // 应收金额
        operateTime: '', // 生成业务时间
        operator: this.addBatchFee.expenseSubList?.[0]?.operator || '', // 操作人
        remark: '' // 备注
      };

      this.addBatchFee.expenseSubList.push(data);
      this.key = Date.now(); // 使用 Date.now() 替代 performance.now()
    }
  }
};
</script>

<style scoped lang="scss">
.app-container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  .addTable {
    flex: 1;
    overflow-y: auto;
    padding: 10px 10px 60px 10px;
  }

  .footerBtn {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid #eeefee;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background-color: #fff;
    z-index: 100;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
  }
}
</style>
<style>
.addStyle {
  color: #00A551;
  cursor: pointer;
  font-size: 18px;
}
.deleteStyle {
  color: #F56C6C;
  cursor: pointer;
  font-size: 18px;
}
</style>
